module.exports = __webpack_public_path__ + "static/media/Eloisa-Mae-Salvacion-Product-Designer-CV.f79b3c7a.pdf";